module.exports = __webpack_public_path__ + "assets/ETHethereum.b1f47250.svg";